import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';

function RegulatoryRepresentationServices() {

  return (
    <div className="font-sans text-gray-800">

      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'Regulatory Services', 'Regulatory Representation Services']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Regulatory Services
        </h2>

        <div className="flex items-center gap-2 mb-2">
          <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Regulatory Representation Services
          </h3>
        </div>


        <h4 className="text-md font-bold text-[#05326D] mb-4 mt-4">
          Your Trusted Partner for Global Regulatory Submissions
        </h4>

        <p className="mb-4 text-[#05326D]">
          <span className="text-sm font-bold text-[#05326D] mb-4">The Electronic Common Technical Document (eCTD)
          </span>
          At FDAc Consultancy, we provide strategic regulatory representation in both the United States and India, enabling
          seamless access to health authorities and accelerating approvals for pharmaceuticals, biologics, cosmetics, and
          medical devices. Our end-to-end support ensures compliance, transparency, and timely execution across all
          regulatory milestones.
        </p>

        <hr className="border-t border-gray-300 mb-8 mt-8" />

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          US FDA Representation & Drug Listing Services
        </h2>
        <p className='text-[#05326D] ml-4'>FDAc acts as your authorized US agent, facilitating direct engagement with the US Food and Drug Administration
          (FDA) for all regulatory submissions. Our services are designed to simplify access and ensure full compliance
          with FDA requirements.</p>


        <div className="flex items-center gap-2 mb-2 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            US Agent Services
          </h3>
        </div>

        <p className="ml-4 mt-2 text-[#05326D]">Official representation for FDA communications</p>
        <p className="ml-4 mt-2 text-[#05326D]">Submission support for IND, NDA, BLA, ANDA, DMF</p>
        <p className="ml-4 mt-2 text-[#05326D]">Lifecycle management of regulatory filings</p>
        <p className="ml-4 mt-2 text-[#05326D]">eCTD publishing and submission via FDA ESG portal</p>

        <div className="flex items-center gap-2 mb-4 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Drug Listing & Establishment Registration
          </h3>
        </div>

        <p className="ml-4 mt-2 text-[#05326D]">Establishment Registration (ER)</p>
        <p className="ml-4 mt-2 text-[#05326D]">Labeler Code Application</p>
        <p className="ml-4 mt-2 text-[#05326D]">National Drug Code (NDC) Assignment & Drug Listing</p>
        <p className="ml-4 mt-2 text-[#05326D]">Annual ER Updates & eDRLS Listing Certification</p>
        <p className="ml-4 mt-2 text-[#05326D]">GDUFA Cover Sheet Filing & Self-Identification</p>
        <p className='ml-4 mt-2 mt-4 text-[#05326D]'> Indian Regulatory Representation – CDSCO & DCGI</p>
        <p className='ml-4 mt-2 text-[#05326D]'> FDAC serves as your authorized Indian agent, guiding you through regulatory approvals with the Central Drugs Standard Control Organization
          (CDSCO) and Drug Controller General of India (DCGI). We support a wide range of product categories including drugs, cosmetics, medical
          devices, biologics, and nutraceuticals.</p>

        <div className="flex items-center gap-2 mb-4 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Regulatory Services
          </h3>
        </div>


        <p className="ml-4 mt-2 text-[#05326D]">New Drug Approvals & Fixed-Dose Combinations (FDCs)</p>
        <p className="ml-4 mt-2 text-[#05326D]">Import License & Product Registration</p>
        <p className="ml-4 mt-2 text-[#05326D]">Global Clinical Trial Applications</p>
        <p className="ml-4 mt-2 text-[#05326D]">BA/BE NOC Coordination</p>
        <p className="ml-4 mt-2 text-[#05326D]">Post-Approval Variations & Renewals</p>
        <p className="ml-4 mt-2 text-[#05326D]">Medical Device & Cosmetic Import Registration</p>
        <p className="ml-4 mt-2 text-[#05326D]">Embassy Attestation & Legalization</p>
        <p className="ml-4 mt-2 text-[#05326D]">Nutraceuticals/Food Supplements Approval via FSSAI</p>
        <p className="ml-4 mt-2 text-[#05326D]">Ethics Committee Registration</p>
        <p className="ml-4 mt-2 text-[#05326D]">Vaccines & Biological Product Approvals</p>

        <div className="flex items-center gap-2 mb-4 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            End-to-End Support
          </h3>
        </div>
        <p className="ml-4 mt-2 text-[#05326D]">Molecule selection & regulatory pathway analysis</p>
        <p className="ml-4 mt-2 text-[#05326D]">Dossier compilation & technical document review</p>
        <p className="ml-4 mt-2 text-[#05326D]">Coordination with trusted BE centers & CROs</p>
        <p className="ml-4 mt-2 text-[#05326D]">Online & offline submission management</p>
        <p className="ml-4 mt-2 text-[#05326D]">Query response handling & government follow-ups</p>
        <p className="ml-4 mt-2 text-[#05326D]">SEC presentation preparation & representation</p>
        <p className="ml-4 mt-2 text-[#05326D]">Commitment to on-time approvals</p>

      </div>
    </div>
  );
}

export default RegulatoryRepresentationServices;
